/** The brush a refinement stroke was painted with. Stored in the poster; ImageRefinementTool.php mirrors the values. */
export enum CutoutRefineTool {
  ERASE = 'erase',
  RESTORE = 'restore',
}

/** One erase or restore brush stroke, on the refinement grid described in background-refinement.library. */
export interface ItemRefinementStrokeObject {
  tool: CutoutRefineTool;
  /** Brush diameter in grid units */
  width: number;
  /** The brush path as flat x0,y0,x1,y1 grid coordinates */
  points: number[];
}

/** The user's erase/restore strokes over the image, replayed in order whenever the image loads. */
export interface ItemRefinementObject {
  strokes: ItemRefinementStrokeObject[];
}

/** What the strokes need from their item: the pre-removal image that Restore brushes paint pixels back from. */
export interface ItemRefinementSource {
  getImageUrlWithBackground(): string;
}
